import ConfirmPasswordChangedPage from "./ConfirmPasswordChangedPage";

export default ConfirmPasswordChangedPage;